import React, { FC, useState } from 'react';
import { FieldRenderProps as WrappedFieldProps } from 'react-final-form';
import { QuickQuoteFormProps } from '../../booking/quote/QuickQuoteTypes';
import { Dropdown, DropdownProps } from '@trip-ux/components';
import { get, isEmpty, isNaN } from 'lodash';

export const GenericDropdown: FC<WrappedFieldProps<string> & QuickQuoteFormProps & DropdownProps> = ({
  input,
  labels,
  meta,
  inputOnChange,
  validateOnActive = true,
  newLabel,
  placeholder,
  isDisabled,
  ...dropDownProps
}) => {
  const [showError, setShowError] = useState(true);
  return(
  <Dropdown
    name={input.name}
    value={input.value || ''}
    onChange={val => {
      const newVal = isNaN(parseInt(val)) ? val : parseInt(val);
      input.onChange(newVal);
      inputOnChange && inputOnChange(newVal);
    }}
    onFocus={(_event) => {
      setShowError(false);
      input.onFocus();
    }}
     onBlur={(_event) => {
        setShowError(true);
        input.onBlur();
      }}

    validateOnActive={validateOnActive}
    {...dropDownProps}
    error={showError && meta.touched && meta.error}
    placeholder={placeholder}
    isDisabled={isDisabled}>
    {!isEmpty(newLabel) ? labels.formLabels[`${newLabel}`] : get(labels, `formLabels.${input.name}`)}
  </Dropdown>
);
}
GenericDropdown.displayName = 'GenericDropdown';
